import React, { useState } from "react";
import api from "../../store/api";
import { showNavbar } from '../../store/modules/appStateSlice';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import Button from "@material-ui/core/Button";
import Navbar from '../shared/Navbar';
import { RootState } from '../../store/rootReducer';
import UserPaneModal from './userPane/UserPaneModal';
import { useHistory, useParams } from 'react-router-dom';
import MapsWithMarker from "../shared/MapsWithMarker";


interface IVehicleLocation {
    latitude: number,
    linearDistance: number,
    longitude: number,
    objectNo: string,
    objectState: number,
    objectUid: string,
    routeDistance: number,
    routeTime: number,
    color: string
}

function NavRightMenu(props: any): JSX.Element {
    return (
        <Button onClick={props.rightButtonClick} endIcon={<KeyboardArrowDownIcon />} style={{ color: "#FFF" }}>{props.userName}</Button>
    )
}

const TrackVehicle = () => {
    const [nearestVehicles, setNearestVehicles] = React.useState<IVehicleLocation[]>([]);
    const dispatch = useDispatch();
    const { authStore } = useSelector((state: RootState) => state);
    const history = useHistory();

    // Use setZoom to change zoom level dynamically
    const [zoom, setZoom] = useState(13);
    // Initial center value (center of australia)
    const [center, setCenter] = useState({ lat: -33.85679100870898, lng: 151.21529457809382 });
    const { vehicleNum } = useParams<{ vehicleNum: string }>();
    const [pollingTrigger, setPollingTrigger] = useState<number>(0);

    const [AVdialogIsOpen, setAVDialogIsOpen] = React.useState(false);
    const AVopenDialog = () => setAVDialogIsOpen(true);
    const AVcloseDialog = () => setAVDialogIsOpen(false);

    React.useEffect(() => {
        dispatch(showNavbar(false));
        startPolling();
    }, [])

    React.useEffect(() => {
        consumeAPI();
    }, [pollingTrigger])

    const startPolling = () => {
        setInterval(() => {
            setPollingTrigger(Math.random() + Math.random());
        }, 20000)
    }

    const consumeAPI = () => {
        api.TrackWebFleetNearestVehicle('', {
            "vehicle": vehicleNum,
            "addrno": "E4:04:39:56:F2:CF",
            "latitude": 0,
            "longitude": 0,
            "priority": 1,
            "maxdistance": 1000,
            "timeZone": "Australia_NSW"
        }).then(({ model: { results } }) => {
            setNearestVehicles(results);
            if (results.length <= 0) return;
            const { latitude, longitude } = results[0];
            setCenter({ lat: latitude / 1000000, lng: longitude / 1000000 });
        })
    }

    return (
        <React.Fragment>
            <Navbar humberMenu={<Button style={{ padding: 0, minWidth: 50, height: "100%", color: "#FFF" }} onClick={() => history.goBack()} ><KeyboardArrowLeftIcon /></Button>} rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ''} rightButtonClick={AVopenDialog} />} />
            <MapsWithMarker nearestVehicles={nearestVehicles} center={center} zoom={zoom} height={"100vh"} />
            <UserPaneModal open={AVdialogIsOpen} onClose={AVcloseDialog} />
        </React.Fragment>
    );
};

export default TrackVehicle;
